/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React from 'react';

export function isPasting(evt: React.KeyboardEvent): boolean {
    return (evt.metaKey || evt.ctrlKey) && evt.key === 'v';
}

export function textIsSelected(evt: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): boolean {
    const {currentTarget} = evt,
        start = currentTarget.selectionStart,
        end = currentTarget.selectionEnd;
    return start != end;
}

export function positionIsAfterComma(position: number | null, value: string): boolean {
    if (position === null) return true;
    if (value.includes('.')) return position > value.indexOf('.');
    if (value.includes(',')) return position > value.indexOf(',');
    return false;
}
